export const WhatsappTemplateButtonTypeEnum = Object.freeze({
  QUICK_REPLY: "QUICK_REPLY",
  URL: "URL",
  COPY_CODE: "COPY_CODE",
  FLOW: "FLOW",
});
